/* eslint-disable no-extend-native, no-eq-null, eqeqeq, no-new-object */

// https://tc39.github.io/ecma262/#sec-array.prototype.find
if (!Array.prototype.find) {
    Object.defineProperty(Array.prototype, 'find', {
        value(predicate) {
            // 1. Let O be ? ToObject(this value).
            if (this == null) {
                throw new TypeError('"this" is null or not defined')
            }

            const o = new Object(this)

            // 2. Let len be ? ToLength(? Get(O, "length")).
            const length_ = o.length >>> 0

            // 3. If IsCallable(predicate) is false, throw a TypeError exception.
            if (typeof predicate !== 'function') {
                throw new TypeError('predicate must be a function')
            }

            // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
            const thisArg = arguments[1]

            // 5. Let k be 0.
            let k = 0

            // 6. Repeat, while k < len
            while (k < length_) {
                // A. Let Pk be ! ToString(k).
                // b. Let kValue be ? Get(O, Pk).
                // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
                // d. If testResult is true, return kValue.
                const kValue = o[k]
                if (predicate.call(thisArg, kValue, k, o)) {
                    return kValue
                }

                // E. Increase k by 1.
                k++
            }

            // 7. Return undefined.
            return undefined
        },
        configurable: true,
        writable: true
    })
}
/* eslint-enable */

const containsInstance = (networks, network, instance) => {
    let found = networks.find((n) => n.id === network)
    if (!found) return false
    found = found.instances.find((i) => i === instance)
    return Boolean(found)
}

const appendLoginParameters = (path, pathParameters, queryParameters = {}) => {
    const {network, instance, lang} = pathParameters

    const endpoint = `${path}/${network}/${instance}/${lang}`

    const finalEndpoint = appendQueryParameters(endpoint, queryParameters)
    return finalEndpoint
}

const appendQueryParameters = (endpoint, queryObject) => {
    endpoint = new URL(endpoint)

    for (const key of Object.keys(queryObject)) {
        endpoint.searchParams.append(key, queryObject[key])
    }

    return endpoint.toString()
}

const sharedCommands = {
    CLOSE_POPUP: 'cxf.announcements.closePopup',
    MARK_AS_READ: 'cxf.announcements.markAsRead',
    SHOW_ANNOUNCEMENTS: 'cxf.announcements.getAllAnnouncements',
    TRACKING: 'cxf.announcements.tracking',
    LINK_CLICKED: 'cxf.announcements.hrefClicked'
}

const ANNOUNCEMENTS_LOCALSTORAGE_KEY =
    'ggs.cxf.announcements.fetchedAnnouncements'

const getHashKey = (game, playername, network, instance) => {
    const k = [game, playername, network, instance].join('_')
    return `ggs.cxf.announcements.${k}.messageHash`
}

// Generate random hash from title+body
// https://stackoverflow.com/a/34842797
const hashCode = (string) => {
    let h = 0
    for (let i = 0; i < string.length; i++)
        // eslint-disable-next-line unicorn/prefer-math-trunc
        h = (Math.imul(31, h) + string.charCodeAt(i)) | 0
    return h
}

const PLUGIN_PREFIX = `CXF-ANNOUNCEMENT`

const logger = {
    info: (...args) => {
        if (process.env.NODE_ENV !== 'production') {
            console.info(
                `%c ${PLUGIN_PREFIX} ->`,
                'background: green; color: yellow',
                ...args
            )
        }
    },
    log: (...args) => {
        if (process.env.NODE_ENV !== 'production') {
            console.info(
                `%c ${PLUGIN_PREFIX} ->`,
                'background: green; color: yellow',
                ...args
            )
        }
    },
    warn: (...args) => {
        if (process.env.NODE_ENV !== 'production') {
            console.warn(
                `%c ${PLUGIN_PREFIX} ->`,
                'background: orange; color: yellow',
                ...args
            )
        }
    },
    error: (...args) => {
        console.error(
            `%c ${PLUGIN_PREFIX} ->`,
            'background: red; color: yellow',
            ...args
        )
    }
}

const subtractArray = (array1, array2) =>
    array1.filter((item) => !array2.includes(item))

module.exports = {
    containsInstance,
    sharedCommands,
    appendLoginParameters,
    appendQueryParameters,
    ANNOUNCEMENTS_LOCALSTORAGE_KEY,
    hashCode,
    getHashKey,
    logger,
    subtractArray
}
